<template>
  <v-app>
    <v-content>
      <StrategySession/>
    </v-content>
  </v-app>
</template>

<script>
import StrategySession from './components/StrategySession'

export default {
  name: 'App',
  components: {
    StrategySession
  },
  data () {
    return {
      //
    }
  }
}
</script>
